/*
 * @Description:
 * @Version: 2.0
 * @Autor: shimnx
 * @Date: 2022-03-16 13:41:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-25 11:07:08
 */
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, Routes, ActivatedRoute } from '@angular/router';
import { apiList } from '@/app/app.api';
import { selfHttp } from '@/app/http-units.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '@/app/@core/auth/auth.service';
@Component({
  selector: 'app-token',
  templateUrl: './token.component.html',
  styleUrls: ['./token.component.scss']
})
export class TokenComponent implements OnInit {
  constructor(
    public translate: TranslateService,
    private authService: AuthService,
    private jwtHelperService: JwtHelperService,
    public api: apiList,
    public router: Router,
    public https: HttpClient,
    private route: ActivatedRoute,
    private http: selfHttp
  ) {}

  ngOnInit(): void {

    this.http.get(
      this.api.projectList.currentUserInfo.path + '?account=' + this.route.snapshot.paramMap.get('token'),
      {},
      (res: any) => {

        localStorage.setItem('userInfo', JSON.stringify(res as any));
        this.login(res);
      }
    );
  }
  login(data) {
    let creds = `client_id=ProjectPlan&client_secret=PROJECT.PLAN.SECRET&grant_type=password&username=${data.userName}&password=Smb123!`;
    // const myHttpHead: any = {
    //     headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', '__tenant': data.tenantId })
    //         .set('Content-Type', 'application/x-www-form-urlencoded')
    // }
    const myHttpHead: any = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }).set(
        'Content-Type',
        'application/x-www-form-urlencoded'
      )
    };
    this.https.post('http://ws003260:16000/connect/token', creds, myHttpHead).subscribe((val: any) => {
      let jwtToken = this.jwtHelperService.decodeToken(val.access_token);


      if (jwtToken) {
        localStorage.setItem('token', val.access_token);
        this.authService.isLoggedIn = true;
        this.router.navigateByUrl('/');
      } else {
        this.authService.isLoggedIn = false;
      }
    });
  }
}
